export default __webpack_public_path__ + "/images/composition_book.png";